
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  PendingSignupWorkflow,
} from '../models';
import {
    PendingSignupWorkflowFromJSON,
    PendingSignupWorkflowToJSON,
} from '../models';

export interface RemoveByAccountIdRequest {
    accountId: string;
}

export interface RemoveByEmailRequest {
    email: string;
}

export interface SearchByAccountIdRequest {
    accountId: string;
}

export interface SearchByEmailRequest {
    email: string;
}

/**
 * 
 */
export class PendingSignupWorkflowApi extends runtime.BaseAPI {

    /**
     * Remove a pending signup workflow by accountId
          */
    async removeByAccountIdRaw(requestParameters: RemoveByAccountIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling removeByAccountId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['accountId'] = requestParameters['accountId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/admin/signup-workflow/by-account-id`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Remove a pending signup workflow by accountId
          */
    async removeByAccountId(requestParameters: RemoveByAccountIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.removeByAccountIdRaw(requestParameters, initOverrides);
    }

    /**
     * Remove a pending signup workflow by email address
          */
    async removeByEmailRaw(requestParameters: RemoveByEmailRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling removeByEmail().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/admin/signup-workflow/by-email`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Remove a pending signup workflow by email address
          */
    async removeByEmail(requestParameters: RemoveByEmailRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.removeByEmailRaw(requestParameters, initOverrides);
    }

    /**
     * Search for a pending signup workflow by account id
          */
    async searchByAccountIdRaw(requestParameters: SearchByAccountIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PendingSignupWorkflow>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling searchByAccountId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['accountId'] = requestParameters['accountId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<PendingSignupWorkflow>({
            path: `/profile/api/admin/signup-workflow/by-account-id`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=PendingSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Search for a pending signup workflow by account id
          */
    async searchByAccountId(requestParameters: SearchByAccountIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PendingSignupWorkflow> {
        const response = await this.searchByAccountIdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Search for a pending signup workflow by email address
          */
    async searchByEmailRaw(requestParameters: SearchByEmailRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PendingSignupWorkflow>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling searchByEmail().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<PendingSignupWorkflow>({
            path: `/profile/api/admin/signup-workflow/by-email`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=PendingSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Search for a pending signup workflow by email address
          */
    async searchByEmail(requestParameters: SearchByEmailRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PendingSignupWorkflow> {
        const response = await this.searchByEmailRaw(requestParameters, initOverrides);
        return response._data;
    }

}
